<button
  type="button"
  class="btn btn-sm btn-outline-primary-accent d-inline-flex align-items-center gap-1 mb-2 text-nowrap"
  title="ซิงค์ใบรับรองจาก ThaiTraces"
  [disabled]="!taxId || isSyncing"
  (click)="sync()">
  @if (isSyncing) {
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  } @else {
    <i class="bi bi-arrow-repeat"></i>
  }
  ซิงค์ใบรับรอง
</button>
